import { j as c } from "./index58.mjs";
import { Button as l } from "@mantine/core";
import { l as s } from "./index62.mjs";
import { forwardRef as u } from "react";
const n = (t, r, i, a) => {
  const o = t.colors[a.color || t.primaryColor];
  if (o) return t.fn.rgba(o[r], i);
}, f = (t, r) => r.variant === "light" ? {
  root: {
    color: n(t, 1, 1, r),
    background: n(t, 7, 0.5, r),
    "&:hover": {
      background: n(t, 6, 0.5, r)
    }
  }
} : r.variant === "outline" ? {
  root: {
    color: "rgba(255,255,255,0.8)",
    background: n(t, 8, 0.6, r),
    border: `1px solid ${n(t, 8, 0.8, r)}`,
    "&:hover": {
      background: n(t, 8, 0.8, r)
    }
  }
} : {}, y = u((t, r) => {
  const { children: i, fontWeight: a, ...o } = t, g = (e) => {
    switch (e.size) {
      case "xs":
        return { padding: "0 10px", height: 28, fontSize: 12 };
      case "sm":
        return { padding: "0 12px", height: 32, fontSize: 13 };
      case "lg":
        return { padding: "0 20px", height: 40 };
      case "xl":
        return { padding: "0 24px", height: 44 };
      default:
        return { padding: "0 16px", height: 36 };
    }
  }, d = {
    style: {
      opacity: t.disabled ? 0.5 : 1,
      ...g(t),
      ...t.style
    },
    styles: (e) => s.merge(
      {
        rightIcon: { marginLeft: 6, marginRight: -6 },
        leftIcon: { marginRight: 6, marginLeft: -6 },
        ...f(e, t)
      },
      t.styles
    ),
    radius: 4,
    gradient: { from: "#4b53e3", to: "#d33bde", deg: 100 }
  };
  return /* @__PURE__ */ c.jsx(l, { ref: r, ...d, ...o, children: i });
});
export {
  y as Button,
  f as getOutlineTheme,
  n as rgba
};
